import React from 'react';
import PropTypes from 'prop-types';

import { Accordion, AccordionDetails, AccordionSummary, makeStyles, Typography } from '@material-ui/core';
import { KeyboardArrowDownOutlined } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    panelDetailsRoot: {
        padding: (props) => (props.disableContainerPadding ? 0 : `${theme.spacing(2)}px ${theme.spacing(3)}px`)
    },
    panelRoot: {
        width: '100%',
        marginBottom: theme.spacing(2),
        border: 0
    },
    panelSummaryRoot: {
        backgroundColor: '#fff',
        '&.Mui-expanded': {
            minHeight: 48,
            maxHeight: 48
        },
        color: 'primary',
        borderBottom: `1px solid ${theme.palette.divider}`
    },
    panelSummaryContent: {
        margin: '0',
        '&.Mui-expanded': {
            margin: '0'
        }
    },
    panelSummaryExpandIcon: {
        padding: 0,
        margin: `${(0 - theme.spacing(1)) / 2}px`
    }
}));

export const ExpansionPanel = ({
    title,
    children,
    disableContainerPadding = false,
    inverted = false,
    allCapsText = true,
    icon,
    ...props
}) => {
    const { panelDetailsRoot, panelRoot, panelSummaryRoot, panelSummaryContent, panelSummaryExpandIcon } = useStyles({
        disableContainerPadding,
        inverted
    });

    const color = inverted ? 'white' : 'primary';

    return (
        <Accordion square={true} elevation={0} className={panelRoot} {...props}>
            <AccordionSummary
                expandIcon={<KeyboardArrowDownOutlined style={{ color }} />}
                aria-controls='panel-content'
                id='panel-header'
                classes={{ root: panelSummaryRoot, content: panelSummaryContent, expandIcon: panelSummaryExpandIcon }}
            >
                {icon}
                <Typography color={color} variant={allCapsText ? 'button' : 'body1'} style={{ lineHeight: '2.0' }}>
                    {title}
                </Typography>
            </AccordionSummary>
            <AccordionDetails classes={{ root: panelDetailsRoot }}>{children}</AccordionDetails>
        </Accordion>
    );
};

ExpansionPanel.propTypes = {
    title: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    disableContainerPadding: PropTypes.bool,
    inverted: PropTypes.bool,
    allCapsText: PropTypes.bool,
    icon: PropTypes.element
};
